export default "__VITE_ASSET__hWocqOt5__"